import React from 'react'
import { Link } from 'gatsby'

export default ({ tags, ...rest }) => (
  <div className='tags'>
    {tags &&
      tags.map(
        (tag, i) =>
          tag && (
            <span key={i} className='tag is-black is-large btn'>
              <Link to={`/blog/tag/${tag}`}>{tag}</Link>
            </span>
          )
      )}
  </div>
)
